import { CSSProperties } from 'react'
import styles from '../../AdminTools.module.css'

export interface HeaderAlignedKontrolleraButtonProps {
  handleClick: () => void
  disabled?: boolean
  style?: CSSProperties
}

export const HeaderAlignedKontrolleraButton = ({
  handleClick,
  disabled = false,
  style,
}: HeaderAlignedKontrolleraButtonProps) => {
  return (
    <div className={styles.headerAlignedButton}>
      <button
        className={styles.kontrollButton}
        onClick={handleClick}
        disabled={disabled}
        style={style}
      >
        Kontrollera
      </button>
    </div>
  )
}
